import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Move } from '@app/move/interfaces/move';
import { I18nKeyType } from '@smooved/core';

@Component({
    selector: 'app-meta-info',
    templateUrl: './meta-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetaInfoComponent {
    @Input() public move: Move;
    @Input() public interviewee: string;

    i18nKeyInterviewee = I18nKeyType.Interviewee;
}
